import { useReducer } from 'react';
import type { AnyAction } from 'redux';
import Immutable from 'immutable';

/**
 * Handles form feedback messages that come from the backend
 * Register anticipated fields via initialState in useFormFeedback(initialState)
 * ie. useFormFeedback({ 'email': null })
 */

const formFeedbackReducer = (state: any, action: AnyAction) => {
    const { payload } = action;

    switch (action.type) {
        case 'SET_SUCCESS':
            // global messages
            return state.set('success', payload.get('message'));
        case 'SET_ERROR':
            // global messages
            if (payload.has('team')) {
                return state.set('global', payload.get('team'));
            }

            if (payload.has('promo')) {
                return state.set('global', payload.get('promo'));
            }

            if (payload.has('reason')) {
                return state.set('global', payload.get('reason'));
            }

            return state.mergeDeep(Immutable.fromJS(payload));
        case 'CLEAR_ERRORS': {
            // clears values but keeps keys
            const clearedState = state.keySeq().reduce((acc: any, key: any) => {
                return acc.set(key, '');
            }, Immutable.Map());
            return clearedState;
        }
        default:
            return state;
    }
};

export const useFormFeedback = (initialState: any) => {
    return useReducer(formFeedbackReducer, initialState);
};
